import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A grid relay / control station: a low concrete control house with a steel door
// and small high windows, a roof-mounted cooling unit and antenna, and an
// outdoor cable tray running to a pair of disconnect insulators on the apron.
// Where the protection relays and SCADA for a feeder live.
const WALL = "#b9bcc0";
const WALL_DK = "#9aa0a6";
const ROOF = "#73787e";
const DOOR = "#5a6066";
const INSUL = "#9aa6ad";
const STEEL = "#878e96";

export const relayStation = defineModel({
  id: "relay-station",
  batchId: "electric",
  name: "Relay station",
  tags: ["building", "electric", "power", "grid", "control", "substation"],
  summary: "A control house for protection relays with outdoor disconnects.",
  footprint: 0.7,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.5, 0.1, 1.1), color: "#6f6f74", position: [0, 0.05, 0] },
      // Control house.
      { geometry: new THREE.BoxGeometry(0.86, 0.52, 0.66), color: WALL, position: [-0.2, 0.36, 0] },
      { geometry: new THREE.BoxGeometry(0.92, 0.07, 0.72), color: ROOF, position: [-0.2, 0.65, 0] },
      // Steel door and two high windows.
      { geometry: new THREE.BoxGeometry(0.2, 0.34, 0.02), color: DOOR, position: [-0.2, 0.27, 0.34] },
      { geometry: new THREE.BoxGeometry(0.03, 0.06, 0.02), color: "#cfcfcf", position: [-0.12, 0.27, 0.36] },
      { geometry: new THREE.BoxGeometry(0.14, 0.1, 0.02), color: "#3a4a55", position: [-0.45, 0.46, 0.34] },
      { geometry: new THREE.BoxGeometry(0.14, 0.1, 0.02), color: "#3a4a55", position: [0.05, 0.46, 0.34] },
      // Roof cooling unit and antenna.
      { geometry: new THREE.BoxGeometry(0.26, 0.1, 0.26), color: WALL_DK, position: [-0.32, 0.73, -0.08] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.012, 0.5, 6), color: STEEL, position: [0.0, 0.95, -0.2] },
      // Outdoor cable tray to a pair of disconnect insulators.
      { geometry: new THREE.BoxGeometry(0.06, 0.05, 0.5), color: STEEL, position: [0.42, 0.18, 0.0] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.035, 0.34, 8), color: INSUL, position: [0.42, 0.37, -0.2] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.035, 0.34, 8), color: INSUL, position: [0.42, 0.37, 0.2] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.012, 0.4, 6), color: "#b87333", position: [0.42, 0.55, 0], rotation: [Math.PI / 2, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.18, 0.04, 0.04), color: "#5a6066", position: [0.42, 0.07, 0.34] },
    ];
  },
  animations: [],
});
